module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 531.34 560.469",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }